const initialState = {
  organizationListContext: [],
  organogramListContext: [],
  userListContext: [],
  roleListContext: [],
  groupListContext: [],
  employeeListContext: [],
  locationListContext: [],
  departmentListContext: [],
  productListContext: [],
  designationListContext: [],
  lookupListContext: [],
  enumListContext: [],
  libraryVendorListContext: [],
};

export default initialState;
